import { LegalDocumentPage } from '../Legal/LegalDocumentPage'
import { rulesContent } from '../Legal/rulesContent'

export const Rules = () => <LegalDocumentPage content={rulesContent} />
